import type { Router } from 'app/app-state';
import { getRouter } from 'app/selectors';
import { useSelector } from 'react-redux';

/** A helper to select the router from the Redux store */
function useRouter(): Router {
  return useSelector(getRouter);
}

export default useRouter;
